import {useTranslation} from "react-i18next";
import {BulkUploader} from "../../../upload/bulk-upload.tsx";
import {
    PackingMode,
    PackingModeUpsertResult,
    UpsertablePackingMode,
    upsertPackingModeVerb,
} from "../../../rpc/webrpc-client.gen.ts";
import {Box} from "@mui/joy";
import {createFileRoute} from "@tanstack/react-router";
import {PageBody, PageHeader, PageShell} from "../../../routing/shell.tsx";
import {TopBar} from "../../../components/TopBar.tsx";
import {useMothership} from "../../../tq/tqx.tsx";

interface CsvPackingModeFood {
    code: string;
    displayName: string;
    unitId: string;
}

function PackingModeCapsule({packingMode}: { packingMode: UpsertablePackingMode | PackingMode }) {
    return <Box>{packingMode.code}・{packingMode.displayName}</Box>;
}

function AdminPackingMode() {
    const {t} = useTranslation();
    const mama = useMothership();
    return <PageShell>
        <PageHeader><TopBar/></PageHeader>
        <PageBody>
            <BulkUploader<CsvPackingModeFood, UpsertablePackingMode, PackingModeUpsertResult>
                entityTypeLabel={t("entity.packingMode")}
                csvToUpsertFood={(csv) => csv}
                upsertFoodCapsule={(food) =>
                    <PackingModeCapsule packingMode={food}/>
                }
                upsertTqo={{
                    mutationKey: [upsertPackingModeVerb],
                    mutationFn: (args) => mama.upsertPackingMode(args)
                        .then(tqrv => tqrv.result),
                }}
                existingId={(result) => result.existingId ?? null}
                newId={(result) => result.newId ?? null}
                completedCapsule={({food}) =>
                    <PackingModeCapsule packingMode={food}/>
                }
                conflictCapsules={(urv) => {
                    return urv.conflict ? [<PackingModeCapsule key="urv.conflict.id"
                                                               packingMode={urv.conflict}/>] : null;
                }}
            />
        </PageBody>
    </PageShell>;
}

export const Route = createFileRoute("/_auth/admin/packing-mode")({
    component: AdminPackingMode,
});
